import React, { Component } from 'react';
import Helmet from 'react-helmet';
import { BrowserRouter as Router } from 'react-router-dom';

import Wrapper from './components/Wrapper';
import Index from './views/Index';

const META = {
  title: '글램 쇼미더뽐 콘테스트',
  description:
    '30초 영상 찍고 1,000만 원 받아 가자! 나의 매력을 영상으로 뽐내면 총상금 2,500만 원부터 크리에이터 기회까지!',
  keywords:
    '글램, 쇼미더뽐 콘테스트, 소셜엔터테인먼트, 글램 라이브, 영상공모전, 영상콘테스트, UCC, 대학생, 대외활동, 공모전',
  image: '/images/meta.png',
  url: '',
};

class App extends Component {
  render() {
    return (
      <Router>
        <Wrapper>
          <Helmet title={META.title}>
            <meta
              name="viewport"
              content="width=device-width, initial-scale=1.0, minimum-scale=1.0, maximum-scale=1.0, user-scalable=yes, viewport-fit=cover"
            />

            <meta name="description" content={META.description} />
            <meta name="keywords" content={META.keywords} />

            <meta property="og:title" content={META.title} />
            <meta property="og:image" content={META.image} />
            <meta property="og:utl" content={META.url} />
            <meta property="og:description" content={META.description} />
            <meta property="og:type" content="website" />

            <link rel="shortcut icon" href="/favicon.ico" type="image/x-icon" />
            <link rel="icon" href="/favicon.ico" type="image/x-icon" />
          </Helmet>
          <Index />
        </Wrapper>
      </Router>
    );
  }
}

export default App;
